/**
 * Scale factor for GLTF assets.
 * GLTF assets are exported in centimeters, but Higharc uses inches internally.
 * This converts from centimeters to inches (100 inches / 2.54 cm per inch).
 */
export const GLTF_ASSET_SCALE = 100 / 2.54;

/**
 * Scale factor for Draco-compressed assets.
 * Draco assets use a different base unit (1 inch / 2.54 cm per inch).
 */
export const DRACO_ASSET_SCALE = 1.0 / 2.54;
